// extracted by mini-css-extract-plugin
export default {"container":"ManelyakMessage_container__nFfSi","message":"ManelyakMessage_message__4GrpU","isManelyakMessage":"ManelyakMessage_isManelyakMessage__rsi0U"};